import { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import { ToastContainer, toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { Card, CardBody, Input, Label, Spinner } from "reactstrap";

import { MediaDto } from "../../interfaces/media";
import { State, UserProfileDto } from "../../interfaces";
import avatar1 from "../../assets/images/users/user-dummy-img.jpg";
import { uploadUserProfilePhoto } from "../../store/actions";

export const ProfilePicture = () => {
  //#region hooks
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  //#endregion

  //#region redux state
  const { response: user } = useSelector(
    (state: any): State<UserProfileDto> => state.account.userProfile
  );

  const {
    loading: updatingProfilePhoto,
    success: updateProfilePhotoSuccess,
    error: updateProfilePhotoError,
    response: updatedProfilePhoto,
  } = useSelector(
    (state: any): State<MediaDto> => state.account.userProfileImage
  );

  //#endregion

  //#region handlers
  const onChangeImage = (event: ChangeEvent<HTMLInputElement>) => {
    const { target } = event;
    const { files } = target;
    if (files && files.length > 0) {
      const imageFile = files[0];
      if (
        !imageFile.name.match(
          /\.(jpg|JPG|jpeg|JPEG|jfif|pjpeg|pjp|png|PNG|webp|gif|GIF)$/
        )
      ) {
        toast.error(t("selectValidImage"), {
          autoClose: 3000,
        });
        return false;
      }
      dispatch(uploadUserProfilePhoto(imageFile));
    }
  };

  //#endregion

  return (
    <Card>
      <ToastContainer />
      <CardBody className="p-4">
        <div className="text-center">
          <div className="profile-user position-relative d-inline-block mx-auto  mb-4">
            <img
              src={updatedProfilePhoto?.path || user?.profilePhoto || avatar1}
              className="rounded-circle avatar-xl img-thumbnail user-profile-image"
              alt="user-profile"
            />
            <div className="avatar-xs p-0 rounded-circle profile-photo-edit">
              <Input
                onChange={onChangeImage}
                id="profile-img-file-input"
                type="file"
                className="profile-img-file-input"
                disabled={updatingProfilePhoto}
              />
              <Label
                htmlFor="profile-img-file-input"
                className="profile-photo-edit avatar-xs"
              >
                <span className="avatar-title rounded-circle bg-light text-body">
                  {updatingProfilePhoto && <Spinner />}
                  {!updatingProfilePhoto && <i className="ri-camera-fill"></i>}
                </span>
              </Label>
            </div>
          </div>
          <h5 className="fs-16 mb-1">
            {i18n.language === "ar" ? user?.name.ar : user?.name.en}
          </h5>
          <p className="text-muted mb-1">
            {" "}
            {i18n.language === "ar"
              ? user?.role?.name?.ar
              : user?.role?.name.en}
          </p>
          <p className="text-muted mb-0" dir="ltr">
            {" "}
            +{user?.phone.countryCode} {user?.phone.phoneNumber}
          </p>
        </div>
      </CardBody>
    </Card>
  );
};
